import { Validators } from '@angular/forms';
import { FieldsOptions } from '@sim/form';

import { Role, RoleMeta } from './role';

export interface User {
  id?: string;
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  /** Id of the role linked */
  role: string;
  password?: string;
  createdAt?: Date | string;
}

export const UserMeta: FieldsOptions<User> = {
  email: { validators: [Validators.required, Validators.email], value: '' },
  firstName: { validators: [Validators.required], value: '' },
  lastName: { validators: [Validators.required], value: '' },
  role: { validators: Validators.required },
  username: { validators: [Validators.required], value: '' },
};
